/* Chosen Stones — theme JS.
   Vanilla port of the Next.js storefront's interactive components:
   mobile menu, scroll reveal, AJAX cart + drawer, product buy box,
   quick add, the discovery quiz, and the "Why Chosen Stones" arch. */

(function () {
  "use strict";

  /* ---------- helpers ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = window.themeSettings && window.themeSettings.moneyFormat;
    var amount = (cents / 100).toFixed(2);
    if (format) return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    return "$" + amount;
  }

  /* ---------- scroll reveal ---------- */

  function initReveal() {
    var els = $$(".reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("reveal-shown"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal-shown");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- mobile menu ---------- */

  function initMobileMenu() {
    var burger = $("[data-menu-toggle]");
    var menu = $("[data-mobile-menu]");
    if (!burger || !menu) return;
    burger.addEventListener("click", function () {
      var open = menu.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    $$("a", menu).forEach(function (a) {
      a.addEventListener("click", function () {
        menu.classList.remove("is-open");
        burger.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* ---------- cart: AJAX + drawer ---------- */

  var cart = {
    open: function () {
      var drawer = $("[data-cart-drawer]");
      var backdrop = $("[data-cart-backdrop]");
      if (!drawer) return;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      if (backdrop) backdrop.classList.add("is-open");
      document.body.classList.add("drawer-open");
    },
    close: function () {
      var drawer = $("[data-cart-drawer]");
      var backdrop = $("[data-cart-backdrop]");
      if (!drawer) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      if (backdrop) backdrop.classList.remove("is-open");
      document.body.classList.remove("drawer-open");
    },

    /* Re-render the drawer + header count via the Section Rendering API. */
    refresh: function () {
      return fetch(window.location.pathname + "?sections=cart-drawer")
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections["cart-drawer"];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-cart-drawer]");
          var current = $("[data-cart-drawer]");
          if (fresh && current) {
            var wasOpen = current.classList.contains("is-open");
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) cart.open();
          }
          var freshCount = doc.querySelector("[data-cart-drawer-count]");
          var headerCount = $("[data-cart-count]");
          if (freshCount && headerCount) {
            var n = freshCount.getAttribute("data-cart-drawer-count") || "0";
            headerCount.textContent = n;
            headerCount.setAttribute("data-count", n);
          }
        });
    },

    add: function (variantId, quantity) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () { return cart.refresh(); });
    },

    change: function (lineKey, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      }).then(function (r) { return r.json(); })
        .then(function () { return cart.refresh(); });
    }
  };
  window.themeCart = cart;

  function initCart() {
    document.addEventListener("click", function (e) {
      var openBtn = e.target.closest("[data-cart-open]");
      if (openBtn) { e.preventDefault(); cart.open(); return; }

      var closeBtn = e.target.closest("[data-cart-close], [data-cart-backdrop]");
      if (closeBtn) { e.preventDefault(); cart.close(); return; }

      /* Quantity +/- and remove — works in the drawer and on the cart page.
         On the cart page a full reload keeps totals server-accurate. */
      var qtyBtn = e.target.closest("[data-qty-change]");
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.getAttribute("data-line-key");
        var qty = parseInt(qtyBtn.getAttribute("data-qty-change"), 10);
        var onCartPage = !!e.target.closest("[data-cart-page]");
        cart.change(key, Math.max(0, qty)).then(function () {
          if (onCartPage) window.location.reload();
        });
        return;
      }

      /* Quick add from a product card (single-variant products) */
      var quick = e.target.closest("[data-quick-add]");
      if (quick) {
        e.preventDefault();
        quick.disabled = true;
        cart.add(quick.getAttribute("data-quick-add"), 1).then(function () {
          quick.disabled = false;
          cart.open();
        }).catch(function () { quick.disabled = false; });
        return;
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") cart.close();
    });
  }

  /* ---------- product buy box ---------- */

  function initBuyBox() {
    $$("[data-buy-box]").forEach(function (box) {
      var variants = JSON.parse($("[data-variants-json]", box).textContent);
      var input = $("[data-variant-id]", box);
      var priceEl = $("[data-price]", box);
      var compareEl = $("[data-compare-price]", box);
      var saveEl = $("[data-save-badge]", box);
      var labelEl = $("[data-selected-label]", box);
      var addBtn = $("[data-add-to-cart]", box);
      var buyBtn = $("[data-buy-now]", box);
      var mainImg = document.querySelector("[data-main-image]");
      var addLabel = addBtn ? addBtn.textContent.trim() : "";

      function current() {
        var id = input.value;
        return variants.find(function (v) { return String(v.id) === String(id); }) || variants[0];
      }

      function render() {
        var v = current();
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) {
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = formatMoney(v.compare_at_price);
        }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = saveEl.getAttribute("data-save-word") + " " + formatMoney(v.compare_at_price - v.price);
        }
        if (labelEl) labelEl.textContent = v.title === "Default Title" ? "" : v.title;
        var soldOut = !v.available;
        if (addBtn) {
          addBtn.disabled = soldOut;
          addBtn.textContent = soldOut ? addBtn.getAttribute("data-soldout-word") : addLabel;
        }
        if (buyBtn) buyBtn.disabled = soldOut;
        if (mainImg && v.featured_image && v.featured_image.src) {
          mainImg.src = v.featured_image.src;
        }
        $$("[data-variant-pill]", box).forEach(function (pill) {
          pill.setAttribute("aria-pressed",
            String(pill.getAttribute("data-variant-pill") === String(v.id)));
        });
      }

      $$("[data-variant-pill]", box).forEach(function (pill) {
        pill.addEventListener("click", function () {
          input.value = pill.getAttribute("data-variant-pill");
          render();
        });
      });

      if (addBtn) {
        addBtn.addEventListener("click", function () {
          var v = current();
          if (!v.available) return;
          addBtn.disabled = true;
          cart.add(v.id, 1).then(function () {
            addBtn.textContent = addBtn.getAttribute("data-added-word");
            addBtn.disabled = false;
            cart.open();
            setTimeout(function () { addBtn.textContent = addLabel; }, 1600);
          }).catch(function () { addBtn.disabled = false; });
        });
      }
      if (buyBtn) {
        buyBtn.addEventListener("click", function () {
          var v = current();
          if (!v.available) return;
          buyBtn.disabled = true;
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: v.id, quantity: 1 })
          }).then(function () { window.location.href = "/cart"; });
        });
      }

      render();
    });

    /* Gallery thumbnails swap the main image (manual pick wins until the
       next variant change, mirroring the React ProductDetail). */
    $$("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var mainImg = document.querySelector("[data-main-image]");
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute("data-thumb");
        $$("[data-thumb]").forEach(function (t) { t.classList.remove("is-current"); });
        thumb.classList.add("is-current");
      });
    });
  }

  /* ---------- discovery quiz ---------- */

  function initQuiz() {
    $$("[data-quiz]", document).forEach(function (quiz) {
      var answer = parseInt(quiz.getAttribute("data-answer"), 10); // 1-based
      var status = $("[data-quiz-status]", quiz);
      var messages = {
        idle: quiz.getAttribute("data-msg-idle"),
        wrong: quiz.getAttribute("data-msg-wrong"),
        right: quiz.getAttribute("data-msg-right")
      };
      var solved = false;
      $$("[data-quiz-option]", quiz).forEach(function (btn, i) {
        btn.addEventListener("click", function () {
          if (solved) return;
          $$("[data-quiz-option]", quiz).forEach(function (b) {
            b.classList.remove("is-picked", "is-correct");
          });
          if (i === answer - 1) {
            solved = true;
            btn.classList.add("is-correct");
            $$("[data-quiz-option]", quiz).forEach(function (b) { b.disabled = true; });
            if (status) status.textContent = messages.right;
          } else {
            btn.classList.add("is-picked");
            if (status) status.textContent = messages.wrong;
          }
        });
      });
    });
  }

  /* ---------- the "Why Chosen Stones" arch ---------- */

  function initArch() {
    var arch = $("[data-arch]");
    if (!arch) return;

    var slots = $$("[data-arch-slot]", arch);
    var keystone = $("[data-arch-keystone]", arch);
    var keyFace = $("[data-arch-keystone-face]", arch);
    var note = $("[data-arch-note]", arch);
    var count = $("[data-arch-count]", arch);
    var refrain = $$("[data-refrain-at]", arch.parentElement);
    var resetBtn = $("[data-arch-reset]", arch.parentElement);
    var finale = $("[data-arch-finale]", arch);

    var defaultNote = note ? note.textContent : "";
    var total = slots.length + 1;
    var placed = 0;
    var cornerstone = false;

    function update() {
      var n = placed + (cornerstone ? 1 : 0);
      if (count) count.textContent = n + " / " + total + " stones";
      refrain.forEach(function (p) {
        p.classList.toggle("is-lit", n >= parseInt(p.getAttribute("data-refrain-at"), 10));
      });
      if (keyFace && !cornerstone) {
        keyFace.classList.toggle("arch__keystone-face--ready", placed === slots.length);
        keyFace.classList.toggle("animate-glow", placed === slots.length);
        keyFace.classList.toggle("arch__keystone-face--idle", placed !== slots.length);
      }
      if (resetBtn) resetBtn.hidden = !cornerstone;
    }

    slots.forEach(function (slot) {
      slot.addEventListener("click", function () {
        if (slot.getAttribute("data-placed") === "true") return;
        slot.setAttribute("data-placed", "true");
        var word = slot.getAttribute("data-word");
        var slotNote = slot.getAttribute("data-note");
        slot.innerHTML = '<span class="arch__stone animate-stone-pop">' + word + "</span>";
        slot.setAttribute("aria-label", "Stone placed: " + word);
        if (note) note.textContent = word + " — " + slotNote;
        placed += 1;
        update();
      });
    });

    if (keystone) {
      keystone.addEventListener("click", function () {
        if (cornerstone) return;
        if (placed !== slots.length) {
          if (note) note.textContent = keystone.getAttribute("data-msg-early");
          return;
        }
        cornerstone = true;
        keyFace.className = "arch__keystone-face arch__keystone-face--set animate-stone-pop";
        keyFace.innerHTML =
          '<span class="arch__keystone-word">✝ Jesus</span>' +
          '<span class="arch__keystone-sub">the Cornerstone</span>';
        keystone.setAttribute("aria-label", "Cornerstone placed: Jesus");
        if (note) note.textContent = keystone.getAttribute("data-msg-set");
        if (finale) finale.hidden = false;
        arch.classList.add("animate-settle");
        update();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        placed = 0;
        cornerstone = false;
        arch.classList.remove("animate-settle");
        if (finale) finale.hidden = true;
        if (note) note.textContent = defaultNote;
        slots.forEach(function (slot, i) {
          slot.setAttribute("data-placed", "false");
          slot.setAttribute("aria-label", "Reveal a hidden stone");
          slot.innerHTML =
            '<span class="arch__slot-empty animate-bob" style="animation-delay:' +
            (i * 0.45) + 's">?</span>';
        });
        keyFace.className = "arch__keystone-face arch__keystone-face--idle";
        keyFace.innerHTML = '<span class="arch__keystone-word">✝</span>';
        update();
      });
    }

    update();
  }

  /* ---------- boot ---------- */

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initMobileMenu();
    initCart();
    initBuyBox();
    initQuiz();
    initArch();
  });
})();
